// removed by extract-text-webpack-plugin
module.exports = {"box":"IZasOlBfB6cWB4vGFrysx","wrap":"_2zB_U04XidRdkOcJxsTSSS","wrapXXS":"_8sjVXHCg2Nhk58rUA6jb7","inlineXXS":"_3kXx2V70ESOp00NEOLsmr6","vertical":"yNomMguakVsBo-EnwkdMg","horizontal":"_3KtKv5IgM1nUmi-zZVPcKF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FlexBox.scss
// module id = 1230
// module chunks = 0